import React, { useContext, useEffect, useRef } from 'react';
import styled, { ThemeContext } from 'styled-components';

import VisionaryContext from '~website/contexts/VisionaryContext';

type TrustpilotThemeAwareProps = React.HTMLAttributes<HTMLDivElement>;

const TrustpilotThemeAware: React.FCWithChildren<TrustpilotThemeAwareProps> = props => {
	const theme = useContext(ThemeContext);
	const visionary = useContext(VisionaryContext);
	const dark = visionary || theme.themeKey === 'dark';

	const ref = useRef(null);

	useEffect(() => {
		if (typeof window !== 'undefined' && window.Trustpilot?.loadFromElement) {
			window.Trustpilot.loadFromElement(ref.current, true);
		}
	}, []);

	return (
		<Wrap {...props}>
			<div
				ref={ref}
				data-locale={'en-GB'}
				data-template-id={'5419b732fbfb950b10de65e5'}
				data-businessunit-id={'5800a84a0000ff0005960599'}
				data-style-height={'24px'}
				data-style-width={'100%'}
				data-theme={dark ? 'dark' : 'light'}
			>
				<a href={'https://uk.trustpilot.com/review/cuvva.com'} target={'_blank'} rel={'noopener noreferrer'} />
			</div>
		</Wrap>
	);
};

const Wrap = styled.div`
	display: inline-block;
	height: 30px;
	min-width: 300px;
`;

export default TrustpilotThemeAware;
